import clsx from 'clsx';
import React from 'react';
import transformMagazineMagnoliaCategory from '../../helpers/transformMagazineMagnoliaCategory';
import {
  MagazineContextProviderProps,
  MagazineContextValue,
} from './interfaces';

const MagazineContext = React.createContext<MagazineContextValue>({
  currentCategory: undefined,
});

export const MagazineContextProvider = ({
  children,
  value,
}: MagazineContextProviderProps) => {
  const currentCategory = transformMagazineMagnoliaCategory(
    value.currentCategory
  );

  const compoundChildren = React.Children.map(children, (child) => {
    if (React.isValidElement<{ className: string }>(child)) {
      return React.cloneElement(child, {
        className: clsx(child.props.className, currentCategory),
      });
    }
    return child;
  });

  const _value = React.useMemo(
    () => ({
      ...value,
      currentCategory,
    }),
    [currentCategory, value]
  );

  return (
    <MagazineContext.Provider value={_value}>
      {compoundChildren}
    </MagazineContext.Provider>
  );
};

export default MagazineContext;
